import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  async toggleMute(event) {
    const checkbox = event.currentTarget
    const method = checkbox.checked ? 'delete' : 'post'
    const request = new FetchRequest(method, checkbox.dataset.muteUrl, { responseKind: 'json' })

    try {
      const response = await request.perform()
      if (!response.ok) this.revert(checkbox)
    } catch {
      this.revert(checkbox)
    }
  }

  // The switch already moved when the change event fired: put it back so it never
  // displays a preference the server refused or never received.
  revert(checkbox) {
    checkbox.checked = !checkbox.checked
  }
}
